$(function() {

	const pdBox = window.pdBox || initializePdBox();

	pdBox.setCookie = function(context) {
		const cookieName = context.element.data('cookie-name');

		if (cookieName) {
			const cookieValueName = context.element.data('cookie-value-name');
			const cookieValue = context.element.data('cookie-value');
			document.cookie = cookieName + '=1;' + (cookieValue && cookieValueName ? ' '+ cookieValueName + '=' + cookieValue : '');
		}
	}

})
